import React from 'react';

const PremiumServiceSection = () => {
  return (
    <section className="px-5 py-12 bg-white">
      <div className="flex flex-col gap-3 mb-10">
        <span className="text-accent font-bold tracking-wider text-xs uppercase">Premium Service</span>
        <h2 className="text-2xl font-bold text-slate-900">
          本来の頭皮判定<br/>
          サービスで分かること
        </h2>
        <p className="text-sm text-slate-600 leading-relaxed">
          簡易診断は"方向性"まで。<br/>
          実際の判定では、あなたの頭皮に合わせてケア方法とサロンメニューを具体的にご提案します。
        </p>
        <div className="bg-slate-50 p-4 rounded-xl border-l-4 border-accent space-y-2 mt-2">
          <p className="text-sm text-slate-600 leading-relaxed font-bold">
            あなたのミライの髪を作るための、パーソナライズされたケアプランを提案します。
          </p>
          <p className="text-xs text-slate-600 leading-relaxed">
            検査はわずか5分で完了。約1ヶ月後に、さらに詳細な分析結果をお届けします。
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-4 mb-10">
        <div className="bg-white border border-slate-100 p-5 rounded-2xl flex gap-4 items-start shadow-sm hover:shadow-md transition-shadow">
          <div className="bg-blue-btn-primary/10 p-3 rounded-xl text-blue-btn-primary shrink-0">
            <span className="material-symbols-outlined">health_and_beauty</span>
          </div>
          <div>
            <h3 className="text-slate-900 font-bold mb-1 text-base">あなた向けのケア提案</h3>
            <p className="text-xs text-slate-500 leading-relaxed">ホームケアの選び方・使い方まで</p>
          </div>
        </div>

        <div className="bg-white border border-slate-100 p-5 rounded-2xl flex gap-4 items-start shadow-sm hover:shadow-md transition-shadow">
          <div className="bg-blue-btn-primary/10 p-3 rounded-xl text-blue-btn-primary shrink-0">
            <span className="material-symbols-outlined">content_cut</span>
          </div>
          <div>
            <h3 className="text-slate-900 font-bold mb-1 text-base">おすすめメニュー提案</h3>
            <p className="text-xs text-slate-500 leading-relaxed">今の状態に合う施術を提案</p>
          </div>
        </div>

        <div className="bg-white border border-slate-100 p-5 rounded-2xl flex gap-4 items-start shadow-sm hover:shadow-md transition-shadow">
          <div className="bg-blue-btn-primary/10 p-3 rounded-xl text-blue-btn-primary shrink-0">
            <span className="material-symbols-outlined">potted_plant</span>
          </div>
          <div>
            <h3 className="text-slate-900 font-bold mb-1 text-base">未来の髪の土台づくり</h3>
            <p className="text-xs text-slate-500 leading-relaxed">続けやすい方法で整える</p>
          </div>
        </div>
      </div>

      <div className="w-full py-4 text-center">
        <p className="text-blue-btn-primary font-bold text-base flex items-center justify-center gap-2">
          <span className="material-symbols-outlined !text-xl">sentiment_satisfied</span>
          気になる方はスタッフにお声がけください
        </p>
      </div>
    </section>
  );
};

export default PremiumServiceSection;
